import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
  TUIChatService,
  TUIStore,
  StoreName,
  IConversationModel,
} from '../../../@aidesk/uikit-engine';
import vue from '../../../adapter-vue';
import { isPC } from '../../../utils/env';
import ToolbarItemContainer from './toolbar-item-container/index.vue';
import { isEnabledMessageReadReceiptGlobal, openSafeUrl, getTo } from '../../../utils/utils';

export default /*@__PURE__*/_defineComponent({
  __name: 'user-define-input-tool',
  props: {
  isH5ToolShow: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: ''
  },
  icon: {
    type: String,
    default: '',
  },
  type: {
    type: Number,
    default: 1
  },
  content: {
    type: String,
    default: ''
  }
},
  setup(__props) {

const { ref } = vue;

const props = __props;

const currentConversation = ref<IConversationModel>();

TUIStore.watch(StoreName.CONV, {
  currentConversation: (conversation: IConversationModel) => {
    currentConversation.value = conversation;
  },
});

const getIcon = (): string => {
  return props.icon;
}

const onIconClick = () => {
  if (props.type === 1 && props.content) {
    TUIChatService.sendTextMessage({
      to: getTo(currentConversation?.value),
      conversationType: currentConversation?.value?.type,
      payload: {
        text: props.content
      },
      needReadReceipt: isEnabledMessageReadReceiptGlobal(),
    });
  } else if (props.type === 2 && props.content) {
    openSafeUrl(props.content);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ToolbarItemContainer, {
    iconFile: getIcon(),
    title: props.title,
    iconWidth: _unref(isPC) ? '20px' : '25px',
    iconHeight: _unref(isPC) ? '20px' : '25px',
    needDialog: false,
    onOnIconClick: onIconClick,
    isH5ToolShow: __props.isH5ToolShow
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(['image-upload', !_unref(isPC) && 'image-upload-h5', 'image-video'])
      }, null, 2)
    ]),
    _: 1
  }, 8, ["iconFile", "title", "iconWidth", "iconHeight", "isH5ToolShow"]))
}
}

})